export default "__VITE_ASSET__e4c3f5b6__"